import { ReactNode } from 'react'

import { Navigate } from 'react-router'

import { SlateLayout } from '@tribeplatform/react-components/LayoutFrame'
import { useAuthMember, useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { Container } from '@tribeplatform/react-ui-kit/Layout'

import { PageLayout } from '../Layout/PageLayout.js'

export const Messaging = ({ children }: { children: ReactNode }) => {
  const {
    data: { network },
  } = useAuthToken()
  const { isGuest } = useAuthMember()

  const { privateMessagingEnabled } = network?.settings?.privateMessaging || {}

  if (!privateMessagingEnabled) {
    return <Navigate to="/" />
  }

  if (isGuest) {
    return <Navigate to="/auth/login" replace />
  }

  return (
    <PageLayout layout={SlateLayout.headerNoSidebar} showFloatingFooter={false}>
      <Container
        size="full"
        spacing="none"
        padding={{ size: 'md', disableOnMobile: true }}
        containerProps={{
          className: 'h-screen max-h-[calc(100dvh-var(--c-header-height))]',
        }}
      >
        <Container
          size="xl"
          spacing="none"
          containerProps={{ className: 'h-full' }}
        >
          {children}
        </Container>
      </Container>
    </PageLayout>
  )
}
